import React, { useState } from 'react';
import {NeuroMessage, useProduct, useNeuroMessages} from "@ignitesales/neuro-application";
import ProductModal from './ProductModal.jsx';

const Product = ({product, addToCart, removeFromCart, productCart, bankSelected}) => {
    const [showProductModal, setShowProductModal] = useState(false);
    const { getMessage } = useNeuroMessages();
    const {
        descriptionAbbreviated,
        name,
        url
    } = useProduct(product);
    const componentClass = 'product';
    const urlBankSelected = bankSelected === "centralbank" ? url : bankSelected === 'jefferson' ? getMessage(`${product.id.toString()}.url.jefferson`) : getMessage(`${product.id.toString()}.url.bankCentral`);

    return <div className={componentClass}>
        <div className={`${componentClass}__title`}>
            <a href={urlBankSelected} target="_blank"><h4>{ name }</h4></a>
            <span className={`${componentClass}__description`}>{ descriptionAbbreviated }</span>
        </div>
        
        <div className={`${componentClass}__details`}>
            <div className={`${componentClass}__actions`}>
                <button className="btn info" onClick={() => setShowProductModal(true)}>
                    <NeuroMessage id="product.moreInfo" tagName="span" />
                    <i aria-hidden="true" class="fa fa-info-circle"></i>
                </button>
                { !productCart.some(p => p.id === product. id) ? 
                    <button className="btn action" onClick={() => addToCart(product.id)}>
                        <NeuroMessage id="product.add" tagName="span" />
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                    </button>
                : 
                    <button className="btn action inCart" onClick={() => removeFromCart(product.id)}>
                        <NeuroMessage id="product.inCart" tagName="span" />
                        <i class="fa fa-check-square" aria-hidden="true"></i>
                    </button>
                }
            </div>
        </div>
        <ProductModal active={showProductModal} bankSelected={bankSelected} onCloseModal={() =>setShowProductModal(!showProductModal)} product={product}/>
    </div>;
};

export default Product;
